import { ORDER_LISTING_FILTERED_QUERY_KEY } from '@src/orders/hooks/useOrdersWithFilters';
import { ORDER_CATEGORIES_QUERY_KEYS } from '@src/orders/hooks/useOrderTabs';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useRefreshOrders = () => {
  const queryClient = useQueryClient();

  const refreshOrders = useCallback(
    (orderId?: string) => {
      void queryClient.resetQueries({ queryKey: ORDER_CATEGORIES_QUERY_KEYS });
      void queryClient.resetQueries({
        queryKey: ORDER_LISTING_FILTERED_QUERY_KEY,
      });

      if (orderId) {
        void queryClient.resetQueries({ queryKey: ['order.listing', orderId] });
      }
    },
    [queryClient],
  );

  return {
    refreshOrders,
  };
};
